import React, { useEffect, useRef } from 'react';

type Props = {
  date: string;
};

const CountdownTimer: React.FC<Props> = ({ date }) => {
  const timerRef = useRef<HTMLSpanElement>(null);
  const targetDate = new Date(date);

  useEffect(() => {
    const format = (n: number) => n.toString().padStart(2, '0');

    const updateTimer = () => {
      const now = new Date();
      let diffMs = now.getTime() - targetDate.getTime();
      if (diffMs < 0) {
        diffMs = 0;
      }

      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      const timeStr = `${hours}:${format(minutes)}:${format(seconds)}`;

      if (timerRef.current) {
        timerRef.current.textContent = timeStr;
      }
    };

    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, [targetDate]);

  return <span ref={timerRef}>0:00:00</span>;
};

export default CountdownTimer;
